
import { Component, Vue } from 'vue-property-decorator'
import { AxiosResponse, AxiosError } from 'axios'

@Component({})
export default class App extends Vue {
  snackbar: boolean = false
  snackbarText: string = ''

  private created () {
    this.$vuetify.theme.dark = true

    this.axios.interceptors.response.use((response: AxiosResponse) => {
      return response
    }, (error: AxiosError) => {
      if (error.response && error.response.status === 403) {
        this.snackbarText = 'You don\'t have required permissions to use this resource'
        this.snackbar = true
      } else if (error.response && error.response.status !== 200 && error.response.status !== 401 && error.response.status !== 403) {
        this.snackbarText = 'Error occured while processing your request'
        this.snackbar = true
      }

      Promise.reject(error)
    })
  }

  goHome () {
    location.href = '/'
  }
}
